import React from 'react';
import useStyle from './navBurgerBlock.style';
import { Divider } from 'components/atoms/Dividers/Divider';
import { classNames } from 'helpers/style/classNames';

interface NavBurgerBlockProps {
  children: JSX.Element;
  withPadding?: boolean;
}

export const NavBurgerBlock = ({
  children,
  withPadding = false
}: NavBurgerBlockProps) => {
  const classes = useStyle();
  return (
    <div
      className={classNames(
        [classes.root],
        [
          {
            condition: withPadding === true,
            classe: classes.padding
          }
        ]
      )}
    >
      <Divider direction="vertical" />
      <div>{children}</div>
    </div>
  );
};
